import React from 'react'
import Link from 'next/link'
import { PrimaryButton } from 'components/core/Buttons'
import styled from 'styled-components'
import { StatusContainer } from './common'
import { useGooAmountInterval, useGooAmountSpring } from 'hooks/gobblers/useGooVirtualBalance'
import { animated } from '@react-spring/web'
import { getCleanNumber } from 'components/factory/GooEquation'
import { cdnRoot } from 'utils/cdn'
import { useAccount } from 'wagmi'
import useContracts from 'hooks/mint/useContracts'
import { useSmartContractReadCall } from 'hooks/react-query-typechain/useSmartContractReadCall'

import { DEFAULT_CHAIN_ID } from 'config'
import { formatEther } from '@ethersproject/units'
function GooStatusCell() {
  const chainId = DEFAULT_CHAIN_ID
  const { address } = useAccount()

  const [artGobblersContract] = useContracts(chainId)

  const gooBalanceQuery = useSmartContractReadCall(artGobblersContract, 'gooBalance', {
    callArgs: [address!],
    enabled: !!address,
  })

  const showNoGooView = gooBalanceQuery.data?.isZero() === true

  // const gooSpring = useGooAmountSpring()
  // const gooVirtualBalanceUpdatingInInterval = useGooAmountInterval(address)
  // console.log('gooVirtualBalanceUpdatingInInterval', gooSpring.amount)
  // const showNoGooView = !gooSpring.amount

  // const gooVirtualBalanceIsLoading = gooVirtualBalanceUpdatingInInterval === undefined

  const fixedFormattingAmount = 6
  const fixedFormattingSmallAmount = 8

  const gooBalance = gooBalanceQuery.data
    ? parseFloat(formatEther(gooBalanceQuery.data)).toFixed(6)
    : '0'

  return (
    <GooContainer>
      <LeftCell>
        <TopText>Goo in your factory</TopText>
        <MiddleText>
          <animated.span>
            {/* {gooSpring.amount.to((c) => getCleanNumber(c, 4, 6))} */}

            {gooBalance}
          </animated.span>
        </MiddleText>
        <Link
          passHref
          href={{
            pathname: '/factory',
          }}
        >
          <PrimaryButton
            as={'a'}
            buttonSize="small"
            style={{ borderRadius: 30, width: 148 }}
            type="button"
          >
            Go to factory
          </PrimaryButton>
        </Link>
      </LeftCell>

      <GooFactoryBG
        src={
          // TODO(johnrjj) - Loading state here would be nice
          gooBalanceQuery.isLoading
            ? `${cdnRoot}/images/factory/empty-goo-factory.gif`
            : showNoGooView
            ? `${cdnRoot}/images/factory/empty-goo-factory.gif`
            : `${cdnRoot}/images/factory/full-goo-factory.gif`
        }
      />
    </GooContainer>
  )
}

const GooContainer = styled(StatusContainer)`
  flex-shrink: 1;
  flex-grow: 1;
`

const TopText = styled.div`
  font-weight: 700;
  font-size: 20px;
  color: black;
`

const LeftCell = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 7;
  // padding-top: 54px;
  padding-left: 52px;
  gap: 6px;
`
const MiddleText = styled.div`
  font-weight: 900;
  font-size: 64px;
  color: black;
`

const GooFactoryBG = styled.img`
  position: absolute;
  object-fit: cover;
  z-index: 1;
  left: 0px;
  height: 100%;
  width: 100%;
`
export default GooStatusCell
